import { createAction, props } from '@ngrx/store';

export const addEvent = createAction(
  '[Common Events] Add Event',
  (payload?: {
    eventName?: string;
    eventType?: string;
    startDate?: string;
    endDate?: string;
    addBackButton?: boolean;
  }) => payload || {}
);

export const addEventSuccess = createAction('[Common Events] Add Event Success', props<{ eventId: string }>());
